
// dev urls
// export const BASE_URL = 'http://localhost:4000';
// export const GQL_URL = 'http://localhost:4000/graphql'
// export const WEB_SOCKET_URL = 'ws://localhost:4000/graphql'

// prod urls
export const BASE_URL = 'https://api.foreverydiamonds.com';
export const GQL_URL = 'https://api.foreverydiamonds.com/graphql'
export const WEB_SOCKET_URL = 'wss://api.foreverydiamonds.com/graphql'